import { defineMessage } from 'react-intl';

export const message = defineMessage({
  description: 'Error message saying the selected provider service is not available',
  defaultMessage: 'Selected Service not available. Choose another service.',
  id: 'S2a5l7',
});

export default () => {
  return message;
};
